// extracted by mini-css-extract-plugin
module.exports =  {"landingPricingPageV4":"WNSPoGBX"};